import {ContractMethod} from '../../Member/DTO/BucketMemberInfoDTO'

export type BucketAttributesJSON = BucketAttributes

export interface BucketAttributes {
  contractMethodList: ContractMethod[]
  isInUseBucketMemberId: boolean
}

export class BucketAttributesDTO implements BucketAttributes {
  contractMethodList: ContractMethod[]
  isInUseBucketMemberId: boolean

  constructor(contractMethodList: ContractMethod[], isInUseBucketMemberId: boolean) {
    this.contractMethodList = contractMethodList
    this.isInUseBucketMemberId = isInUseBucketMemberId
  }

  static fromJSON(jsonObject: BucketAttributesJSON): BucketAttributesDTO {
    return new BucketAttributesDTO(
      jsonObject.contractMethodList,
      jsonObject.isInUseBucketMemberId,
    )
  }
}
